import React from 'react'
import { Box } from 'components/ui'
import frame from './frame.svg'

export const PersonalizedSchedules = () => (
  <Box
    width="516px"
    height="365px"
    display="flex"
    justifyContent="center"
    position="relative"
    backgroundImage={`url(${frame})`}
    backgroundRepeat="no-repeat"
    backgroundSize="cover"
    backgroundPosition="0 5px"
  ></Box>
)

export default PersonalizedSchedules
